module.exports = __webpack_public_path__ + "img/empty.98f355db.png";